module.exports = __webpack_public_path__ + "static/media/01-galeria-01-bulgary-mobile@2x.405222ec.jpg";